import { FaWhatsapp } from "react-icons/fa";

export const AppWhatsappIcon = () => {
  return (
    <div className="bg-green-600 text-light p-1 rounded-full flex items-center justify-center">
      <FaWhatsapp className="h-4 w-4 md:h-5 md:w-5" />
    </div>
  );
};
